import { render, staticRenderFns } from "./DownloadTab.vue?vue&type=template&id=046d92e7&scoped=true&"
import script from "./DownloadTab.vue?vue&type=script&lang=js&"
export * from "./DownloadTab.vue?vue&type=script&lang=js&"
import style0 from "./DownloadTab.vue?vue&type=style&index=0&id=046d92e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d92e7",
  null
  
)

export default component.exports